import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"


class ConfiguracaoAdmin extends Component {



  constructor(props) {
    super(props);

    this.state ={
      bannersite:null,
      bannersite2:null,
      bannersite3:null,
      bannermobile: null,
      configuracao: [],
      telefone:null,
      email:null,
      nome:null,
      endereco:null,
      whatsapp:null,
      whatsapptext:null,
      cardtext1:null,
      cardtext2:null,
      cardtext3:null,
      tokenpagseguro:null,
      emailpagseguro:null,


      apikey_paghiper:null,
      token_paghiper:null,
      datavencerboleto:"",
      horagerboleto:"",
      diagboletoantvenc:"",



      prilembrancapagboleto:"",
      seglembrancapagboleto:"",
      terlembrancapagboleto:"",
      qualembrancapagboleto:"",
      quilembrancapagboleto:""

  
    }
   
  }

  

  async componentDidMount(){
    const response = await api.post("/configuracao/admshown");
    this.setState({ configuracao: response.data,
      telefone:response.data.telefone,
      email:response.data.email,
      nome:response.data.nome,
      endereco:response.data.endereco,
      whatsapp:response.data.whatsapp,
    whatsapptext:response.data.whatsapptext,
    cardtext1:response.data.cardtext1,
    cardtext2:response.data.cardtext2,
    cardtext3:response.data.cardtext3,
    emailpagseguro:response.data.emailpagseguro,
    tokenpagseguro:response.data.tokenpagseguro,

    apikey_paghiper:response.data.apikey_paghiper,
    token_paghiper:response.data.token_paghiper,
    datavencerboleto:response.data.datavencerboleto,
      horagerboleto:response.data.horagerboleto,
      diagboletoantvenc:response.data.diagboletoantvenc,



      prilembrancapagboleto:response.data.prilembrancapagboleto,
      seglembrancapagboleto:response.data.seglembrancapagboleto,
      terlembrancapagboleto:response.data.terlembrancapagboleto,
      qualembrancapagboleto:response.data.qualembrancapagboleto,
      quilembrancapagboleto:response.data.quilembrancapagboleto
     });

     console.log(this.state);
  }


  onChangesite = e => {
    let files = e.target.files || e.dataTransfer.files;
  if (!files.length)
  return;
  this.createImagesite(files[0]);
  }



  onChangesite2 = e => {
    let files = e.target.files || e.dataTransfer.files;
  if (!files.length)
  return;
  this.createImagesite2(files[0]);
  }



  onChangesite3 = e => {
    let files = e.target.files || e.dataTransfer.files;
  if (!files.length)
  return;
  this.createImagesite3(files[0]);
  }


  
  onChangemobile = e => {

    let files = e.target.files || e.dataTransfer.files;
    if (!files.length)
          return;

    this.createImagemobile(files[0]);

   
  }



  createImagesite(file) {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({
        bannersite: e.target.result
      })
    };
    reader.readAsDataURL(file);
    
  }

  createImagesite2(file) {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({
        bannersite2: e.target.result
      })
    };
    reader.readAsDataURL(file);
    
  }


  createImagesite3(file) {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({
        bannersite3: e.target.result
      })
    };
    reader.readAsDataURL(file);
    
  }



  createImagemobile(file) {
    let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({
        bannermobile: e.target.result
      })
    };
    reader.readAsDataURL(file);
    
  }




  



  onFormSubmit = async e =>{
    e.preventDefault() ;
    const { nome,telefone,bannersite, bannermobile, bannersite2,bannersite3, email, endereco, whatsapp, whatsapptext, emailpagseguro, tokenpagseguro,
      cardtext1,cardtext2,cardtext3, apikey_paghiper, token_paghiper,
    diagboletoantvenc, horagerboleto,datavencerboleto,
  prilembrancapagboleto,seglembrancapagboleto,terlembrancapagboleto,qualembrancapagboleto } = this.state;
      if (!nome || !telefone || !email || !endereco || !whatsapp || !whatsapptext || !cardtext1 
        || !cardtext2 || !cardtext3 || !emailpagseguro || !tokenpagseguro || !apikey_paghiper || !token_paghiper
        || !diagboletoantvenc || !horagerboleto || !datavencerboleto
        || !prilembrancapagboleto || !seglembrancapagboleto ) {
          this.setState({ error: "Preencha os dados antes de editar!",
        success:null });

        console.log(this.state)
      } else {
      const response = await api.post("/admin/configuracao/edit", { bannersite2,bannersite3,nome,telefone,bannersite, bannermobile, email,
         endereco,whatsapp, whatsapptext, cardtext1,cardtext2,cardtext3, emailpagseguro, tokenpagseguro,
        apikey_paghiper, token_paghiper,diagboletoantvenc, horagerboleto,datavencerboleto,
        prilembrancapagboleto,seglembrancapagboleto,terlembrancapagboleto,qualembrancapagboleto });
       

        if(response.data.id){
          this.setState({ success: "Configuração Atualizada!" , error:null,
        });
        }

      }
  }



  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-4 p-4">     

        <h4>Configurações</h4>     
        <br></br>
        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}
        <form onSubmit={this.onFormSubmit}>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome Faculdade</label>
                    <input type="text" defaultValue={this.state.nome} class="form-control" onChange={e => this.setState({ nome: e.target.value })} />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Telefone</label>
                    <input type="text" defaultValue={this.state.telefone} class="form-control" onChange={e => this.setState({ telefone: e.target.value })} placeholder="Telefone da Instituição" />
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">E-mail Contato</label>
                    <input type="text" defaultValue={this.state.email} class="form-control" onChange={e => this.setState({ email: e.target.value })} placeholder="Novo Nome" />
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">E-mail Pagseguro</label>
                    <input type="text" defaultValue={this.state.emailpagseguro} class="form-control" onChange={e => this.setState({ emailpagseguro: e.target.value })} placeholder="Novo codigo" />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Token Pagseguro</label>
                    <input type="text" defaultValue={this.state.tokenpagseguro} class="form-control" onChange={e => this.setState({ tokenpagseguro: e.target.value })} placeholder="Novo codigo" />
                </div>



                <div class="form-group">
                    <label for="exampleFormControlInput1">Api Key Paghiper</label>
                    <input type="text" defaultValue={this.state.apikey_paghiper} class="form-control" onChange={e => this.setState({ apikey_paghiper: e.target.value })} placeholder="Novo codigo" />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Token Paghiper</label>
                    <input type="text" defaultValue={this.state.token_paghiper} class="form-control" onChange={e => this.setState({ token_paghiper: e.target.value })} placeholder="Novo codigo" />
                </div>

                <br></br><br></br>
                <h4>Financeiro</h4>
                <br></br>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Qtd Dias para Gerar Boleto antes do vencimento</label>
                    <input type="number" min="1" max="120" defaultValue={this.state.diagboletoantvenc} class="form-control" onChange={e => this.setState({ diagboletoantvenc: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Dia do mês para vencer Boleto</label>
                    <input type="number" min="1" max="31" defaultValue={this.state.datavencerboleto} class="form-control" onChange={e => this.setState({ datavencerboleto: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Horário para emissão de boletos</label>
                    <input type="time" defaultValue={this.state.horagerboleto} class="form-control" onChange={e => this.setState({ horagerboleto: e.target.value })}  />
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Enviar 1º E-mail Lembrança antes de vencer</label>
                    <input type="number" defaultValue={this.state.prilembrancapagboleto} class="form-control" onChange={e => this.setState({ prilembrancapagboleto: e.target.value })}  />
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Enviar 2º E-mail Lembrança antes de vencer</label>
                    <input type="number" defaultValue={this.state.seglembrancapagboleto} class="form-control" onChange={e => this.setState({ seglembrancapagboleto: e.target.value })}  />
                </div>


                <div class="form-group">
                    <label for="exampleFormControlInput1">Enviar 3º E-mail Lembrança antes de vencer</label>
                    <input type="number" defaultValue={this.state.terlembrancapagboleto} class="form-control" onChange={e => this.setState({ terlembrancapagboleto: e.target.value })}  />
                </div>


                <div class="form-group">
                    <label for="exampleFormControlInput1">Enviar 4º E-mail Lembrança antes de vencer</label>
                    <input type="number" defaultValue={this.state.qualembrancapagboleto} class="form-control" onChange={e => this.setState({ qualembrancapagboleto: e.target.value })}  />
                </div>


                
                



                <br></br>
                <br></br>
                <h3>Dados de Exibição</h3>
                <br></br>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Endereço</label>
                    <input type="text" defaultValue={this.state.endereco} class="form-control" onChange={e => this.setState({ endereco: e.target.value })}  />
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Telefone Whatsapp</label>
                    <input type="text" defaultValue={this.state.whatsapp} 
                    class="form-control" onChange={e => this.setState({ whatsapp: e.target.value })} />
                   
                </div>


                <div class="form-group">
                    <label for="exampleFormControlInput1">Texto Whatsapp</label>
                    <textarea rows="2"  cols="53"  defaultValue={this.state.whatsapptext} class="form-control" 
                    onChange={e => this.setState({ whatsapptext: e.target.value })}>
                    </textarea>
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Card 1</label>
                    <textarea rows="3"  cols="53"  defaultValue={this.state.cardtext1} class="form-control" 
                    onChange={e => this.setState({ cardtext1: e.target.value })} >
                    </textarea>
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Card 2</label>
                    <textarea rows="3"  cols="53"  defaultValue={this.state.cardtext2} class="form-control" 
                    onChange={e => this.setState({ cardtext2: e.target.value })} >
                    </textarea>
                </div>

                <div class="form-group">
                    <label for="exampleFormControlInput1">Card 3</label>
                    <textarea rows="3"  cols="53"  defaultValue={this.state.cardtext3} class="form-control" 
                    onChange={e => this.setState({ cardtext3: e.target.value })} >
                    </textarea>
                </div>


                <div class="form-group">

                <label for="exampleFormControlInput1">Banner Site</label>
                <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text" >Upload</span>
                </div>
                <div class="custom-file">
                  <input type="file" class="custom-file-input" 
                   onChange={this.onChangesite}
                    aria-describedby="inputGroupFileAddon01" />
                  <label class="custom-file-label" for="inputGroupFile01">Escolher Arquivo</label>
                </div>


                </div>




                

                </div>








                <div class="form-group">

                <label for="exampleFormControlInput1">Banner Site 2</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" >Upload</span>
                    </div>
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" 
                      onChange={this.onChangesite2}
                        aria-describedby="inputGroupFileAddon01" />
                      <label class="custom-file-label" for="inputGroupFile01">Escolher Arquivo</label>
                    </div>
                  </div>
                </div>


                <div class="form-group">

                <label for="exampleFormControlInput1">Banner Site 3</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" >Upload</span>
                    </div>
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" 
                      onChange={this.onChangesite3}
                        aria-describedby="inputGroupFileAddon01" />
                      <label class="custom-file-label" for="inputGroupFile01">Escolher Arquivo</label>
                    </div>
                  </div>
                </div>






                <div class="form-group">

                <label for="exampleFormControlInput1">Banner Mobile</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" >Upload</span>
                    </div>
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" 
                      onChange={this.onChangemobile}
                        aria-describedby="inputGroupFileAddon01" />
                      <label class="custom-file-label" for="inputGroupFile01">Escolher Arquivo</label>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                <button type="submit" class="btn btn-primary mb-2">Atualizar Configuração</button>

                </div>

        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(ConfiguracaoAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/configuracao.js